import base58 from "../utils/base58";
import utils from "../utils/utils";

export default {
    isValidAddress(address) {
        let decoded = false;
        try {
            decoded = base58.decode(address);
        } catch (e) {
            
            // if decoding fails, assume invalid address
            return false;
        }

        if (decoded) {
            const { length } = decoded;
            const checksum = utils.toHex(decoded.slice(0, 4));
            const body = utils.toHex(decoded.slice(4, length));
            let crc = utils
                .crc32b(utils.hex2bin(body))
                .toString(16);

            // left pad additional 0 if string length is not even
            if(crc.length % 2 > 0) {
                crc = '0' + crc;
            }

            crc = crc.match(/.{1,2}/g)
                .reverse()
                .join("")

            return checksum === crc;
        }
        return false;
    },
};
